export const BUTTONS_SKELETON = [{
    name: 'BaseButtons',
    type: 'div'
}];
